<template>
  <div
    id="how-it-works"
    class="w-full bg-sw_gray-50 md:px-16 md:py-10"
  >
    <div class="container">
      <div
        class="flex items-center justify-between px-4 py-3 text-base font-bold md:hidden md:px-6 lg:px-8"
        @click="isOpen = !isOpen"
      >
        {{ tr('pages.sales.buy.howItWorks.title') }}

        <div class="flex-shrink-0 ml-4">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.75 13.44" v-bind:svg-inline="''" :class="['h-4 w-4 transform', isOpen ? 'rotate-0' : '-rotate-90']" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M11.313 12.026L23.334.006l1.414 1.413-12.02 12.021z"/><path d="M.006 1.417L1.42.002l12.021 12.021-1.414 1.415z"/></svg>
        </div>
      </div>

      <div class="hidden pb-6 md:block">
        <p class="font-bold md:text-lg xl:text-2xl">
          {{ tr('pages.sales.buy.howItWorks.title') }}
        </p>
      </div>

      <div :class="['w-full flex-col py-6 px-4 md:px-0 md:pt-2 md:pb-0 md:flex-row md:flex md:space-x-12', isOpen ? '' : 'hidden']">
        <div class="flex items-center mb-6 md:w-1/3 md:mb-0">
          <div class="flex-shrink-0">
            <div class="mr-4">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M24.364 16a1.454 1.454 0 00-2.91 0v.727h-.363V14.55v-.004a1.454 1.454 0 00-2.909 0v1.818h-.364v-2.545a1.455 1.455 0 00-2.909 0V16h-.363V7.636a1.455 1.455 0 00-2.91 0l-.005 13.088-.717.088-1.06-4.278a1.455 1.455 0 00-1.832-1.04c-.75.224-1.171 1.024-.982 1.784l1.571 6.3a7.273 7.273 0 007.057 5.513h1.423a7.273 7.273 0 007.273-7.273V16z" fill="#333"/><path d="M10.91 11.665v-1.4a3.412 3.412 0 01-1.237-2.629 3.422 3.422 0 013.418-3.418 3.422 3.422 0 013.418 3.418 3.412 3.412 0 01-1.236 2.63v1.399a4.586 4.586 0 002.4-4.029 4.587 4.587 0 00-4.582-4.582 4.587 4.587 0 00-4.582 4.582c0 1.737.972 3.252 2.4 4.029z" fill="#333"/></svg>
            </div>
          </div>
          <div class="flex-1 pt-1 mt-0.5 md:mt-0 md:pt-0">
            <p class="text-sm leading-snug xl:text-lg md:max-w-64">
              {{ tr('pages.sales.buy.howItWorks.step1') }}
            </p>
          </div>
        </div>

        <div class="flex items-center mb-6 md:w-1/3 md:mb-0">
          <div class="flex-shrink-0">
            <div class="mr-4 md:mr-4">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M4.393 14.091h21.039v4.095a5.076 5.076 0 011.478.4v-9.78a1.43 1.43 0 00-1.427-1.427H4.341a1.43 1.43 0 00-1.426 1.427v12.47c0 .79.646 1.426 1.426 1.426h15.015a5.525 5.525 0 01.472-1.478H4.393V14.09zm21.039-5.234v1.806H4.392V8.857h21.04z" fill="#333"/><path d="M27.813 20.547a4.348 4.348 0 00-6.158 0 4.348 4.348 0 000 6.157 4.348 4.348 0 006.158 0 4.348 4.348 0 000-6.157zm-2.75 5.808l-.873-.872 1.262-1.262h-3.438v-1.232h3.418l-1.252-1.252.872-.872 2.75 2.75-2.74 2.74z" fill="#333"/></svg>
            </div>
          </div>
          <div class="flex-1 pt-1 mt-0.5 md:mt-0 md:pt-0">
            <p class="text-sm leading-snug xl:text-lg md:max-w-64">
              {{ tr('pages.sales.buy.howItWorks.step2') }}
            </p>
          </div>
        </div>

        <div class="flex items-center mb-6 md:w-1/3 md:mb-0">
          <div class="flex-shrink-0">
            <div class="mr-4 md:mr-4">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M29.059 22.029a.133.133 0 00-.1-.046H3.04a.132.132 0 00-.13.152c.003.024.392 2.408 3.406 2.408h19.366c3.014 0 3.402-2.384 3.407-2.408a.134.134 0 00-.031-.106zm-11.04 1.68h-4.04v-.892h4.04v.891zM5.716 21.056h20.568c.295 0 .534-.24.534-.534V7.992a.534.534 0 00-.534-.535H5.716a.534.534 0 00-.534.534v12.53c0 .296.239.535.534.535zm1.336-11.73h17.896v9.86H7.052v-9.86z" fill="#333"/></svg>
            </div>
          </div>
          <div class="flex-1 pt-1 mt-0.5 md:mt-0 md:pt-0">
            <p class="text-sm leading-snug xl:text-lg md:max-w-64">
              {{ tr('pages.sales.buy.howItWorks.step3') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HowItWorks from '~brand-components/base/sale/how-it-works'

export default HowItWorks.extend()
</script>
